import { Component } from "react";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../../../common_components/exhibitor_module_topmenu";

class FreightForward extends Component {

    //Initialize Constructor
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false
        }
    }

    render() {
        const { isLoading } = this.state
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <ExhibitorHeader />
                <ExhibitorDrawer />
                <div className="main-content with-dr-container">
                    <div className="">
                        <div className="row">
                            <ExhibitorTopMenu />
                        </div>
                        <div className="row">
                            <div className="col-xl-12 p-3">
                                <div className="card rounded-0 pt-1">
                                    <div className="card-body p-2">
                                        <h3 className="card-title pb-0 mb-0 pt-2" style={{ fontSize: 15 }}>
                                            Logistic vendor Contact Details
                                        </h3>
                                        <hr />
                                        <div className="mt-1">
                                            <p>
                                                <i className="fa fa-user" /> <strong>Ms. Diana N. Mburu</strong>{" "}
                                                <br />
                                                Head of Fairs &amp; Exhibitions Schenker (Kenya) Limited
                                                <br />
                                                PO Box 46757 <br />
                                                Nairobi 00100 <br />
                                                <i className="fa fa-home" /> Schenker House, 1 Freight Lane
                                                Cargo Village, JKIA
                                                <br />
                                                <i className="fa fa-phone" /> +254 20 776 9418 / +254 20 776
                                                9419
                                                <br />
                                                <i className="fa fa-phone" /> +254 706 340 200
                                                <br />
                                                <i className="fa fa-envelope" /> diana.mburu@dbschenker.com
                                                <br />
                                                <i className="fa fa-globe" /> www.dbschenker.com
                                            </p>
                                            <div className="row mt-3">
                                                <hr />
                                                <h3
                                                    className="card-title pb-0 mb-0 mb-4 text-primary"
                                                    style={{ fontSize: 14 }}
                                                >
                                                    ITME Africa &amp; Middle East 2023 TABLE 1: ONSITE HANDLING
                                                    TARIFF{" "}
                                                </h3>
                                                <div className="table-responsive">
                                                    <table className="table table-bordered ">
                                                        <tbody>
                                                            <tr>
                                                                <th colSpan={3} />
                                                                <th colSpan={2} className="text-center">
                                                                    <strong>Schenker (Kenya) Limited</strong>
                                                                </th>
                                                            </tr>
                                                            <tr>
                                                                <th style={{ width: 400 }}>PARTICULARS</th>
                                                                <th style={{ width: 200 }} />
                                                                <th style={{ width: 125 }} />
                                                                <th
                                                                    style={{ width: 200 }}
                                                                    colSpan={2}
                                                                    className="text-center"
                                                                >
                                                                    <strong>
                                                                        INTERNATIONAL RATE
                                                                        <strong />
                                                                    </strong>
                                                                </th>
                                                            </tr>
                                                        </tbody>
                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    <strong>
                                                                        ONSITE HANDLING &amp; FREIGHT FORWARDERS
                                                                    </strong>
                                                                </td>
                                                                <td>
                                                                    <strong>UNIT</strong>
                                                                </td>
                                                                <td />
                                                                <td className="text-center">
                                                                    <strong>By Sea</strong>
                                                                </td>
                                                                <td className="text-center">
                                                                    <strong>By Air</strong>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <strong>DESCRIPTION OF ITEMS UPTO 5000 KGS.</strong>
                                                                </td>
                                                                <td />
                                                                <td />
                                                                <td className="text-center">
                                                                    <strong>Per CBM</strong>
                                                                </td>
                                                                <td className="text-center">
                                                                    <strong>Per KG</strong>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    OFFLOADING AT VENUE AND SHIFTING TO BOOTH (ONE LIFT
                                                                    ONLY){" "}
                                                                </td>
                                                                <td>PER 500 KGS/PER CBM</td>
                                                                <td className="text-center">MIN 150</td>
                                                                <td className="text-center">$ 40</td>
                                                                <td className="text-center">$ 0.40</td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    UN-PACKING &amp; DE-PALLETISATION IN ONE OPERATION{" "}
                                                                </td>
                                                                <td>PER 500 KGS/PER CBM</td>
                                                                <td className="text-center">MIN 100</td>
                                                                <td className="text-center">$ 40</td>
                                                                <td className="text-center">$ 0.40</td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    POSITIONING &amp; RE-POSITIONING OF THE EXHIBITS (EACH
                                                                    TIME) IF APPLICABLE
                                                                </td>
                                                                <td>PER 500 KGS/PER CBM</td>
                                                                <td className="text-center">MIN 50</td>
                                                                <td className="text-center">$ 30</td>
                                                                <td className="text-center">$ 0.30</td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    REMOVAL OF EMPTIES FOR STORAGE &amp; RETURN AFTER
                                                                    CLOSURE OF THE SHOW
                                                                </td>
                                                                <td>PER CBM</td>
                                                                <td className="text-center">MIN 75 per one way trip</td>
                                                                <td className="text-center">$ 30</td>
                                                                <td className="text-center">$ 0.20</td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    REMOVAL FROM STAND AND LOADING ON VEHICLE IN ONE
                                                                    OPERATION
                                                                </td>
                                                                <td>PER 500 KGS/PER CBM</td>
                                                                <td className="text-center">MIN 150</td>
                                                                <td className="text-center">$ 45</td>
                                                                <td className="text-center">$ 0.40</td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    RE-PACKING OF EXHIBITS OR PALLETISATION OF EXHIBITS
                                                                    WITH SAME PACKING MATERIAL
                                                                </td>
                                                                <td>PER 500 KGS/PER CBM</td>
                                                                <td className="text-center">MIN 150</td>
                                                                <td className="text-center">$ 20</td>
                                                                <td className="text-center">$0.15/Kg</td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    RE-PACKING OF EXHIBITS OR PALLETISATION OF EXHIBITS
                                                                    WITH SAME PACKING MATERIAL
                                                                </td>
                                                                <td>PER 500 KGS/PER CBM</td>
                                                                <td className="text-center">MIN 150</td>
                                                                <td className="text-center">$ 20</td>
                                                                <td className="text-center">$0.15/Kg</td>
                                                            </tr>
                                                            <tr style={{ backgroundColor: "#ddd" }}>
                                                                <td colSpan={5}>HEAVY LIFT CHARGES</td>
                                                            </tr>
                                                            <tr>
                                                                <td>ABOVE 3000 KGS, BELOW 5000 KGS (SINGLE)</td>
                                                                <td className="text-center">Extra</td>
                                                                <td />
                                                                <td colSpan={2} className="text-center">
                                                                    USD 25.00 per 1,000 kg
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>ABOVE 5000 KGS, BELOW 8000 KGS (SINGLE)</td>
                                                                <td className="text-center">Extra</td>
                                                                <td />
                                                                <td colSpan={2} className="text-center">
                                                                    USD 25.00 per 1,000 kg
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>ABOVE 8000 KGS (SINGLE)</td>
                                                                <td className="text-center">Extra</td>
                                                                <td className="text-center">
                                                                    Exhibits exceeding 8,000 kg per package will be
                                                                    subjected to an individual quotation when the
                                                                    dimensions and weights are provided.{" "}
                                                                </td>
                                                                <td colSpan={2} className="text-center">
                                                                    <strong>Subject to Quotation</strong>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan={5} style={{ backgroundColor: "#ddd" }}>
                                                                    HIRE OF EQUIPMENTS FOR ASSEMBLY AND ERECTION OF
                                                                    MACHINES
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>HYDRAULIC PALLETS - 2 Tons</td>
                                                                <td className="text-center">Per Hour/ MIN</td>
                                                                <td className="text-center">MIN 2 HOURS</td>
                                                                <td className="text-center" colSpan={2}>
                                                                    $30 (+16% VAT)
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>FORKLIFT - 3 Tons</td>
                                                                <td className="text-center">Per Hour/ MIN</td>
                                                                <td className="text-center">MIN 3 HOURS</td>
                                                                <td className="text-center" colSpan={2}>
                                                                    $70 (+16% VAT)
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>FORKLIFT - 5 Tons</td>
                                                                <td className="text-center">Per Hour/ MIN</td>
                                                                <td className="text-center">MIN 3 HOURS</td>
                                                                <td className="text-center" colSpan={2}>
                                                                    $90 (+16% VAT)
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>FORKLIFT - 10 Tons</td>
                                                                <td className="text-center">Per Hour/ MIN</td>
                                                                <td className="text-center">MIN 3 HOURS</td>
                                                                <td className="text-center" colSpan={2}>
                                                                    $145 (+16% VAT)
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>CRANE - 10 Tons</td>
                                                                <td className="text-center">Per Hour/ MIN</td>
                                                                <td className="text-center">MIN 2 HOURS</td>
                                                                <td className="text-center" colSpan={2}>
                                                                    $ 145 (+16%VAT)
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>CRANE - 12 Tons</td>
                                                                <td className="text-center">Per Hour/ MIN</td>
                                                                <td className="text-center">MIN 2 HOURS</td>
                                                                <td className="text-center" colSpan={2}>
                                                                    {" "}
                                                                    $ 165 (+16%VAT)
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>CRANE - 15 Tons</td>
                                                                <td className="text-center">Per Hour/ MIN</td>
                                                                <td className="text-center">MIN 2 HOURS</td>
                                                                <td className="text-center" colSpan={2}>
                                                                    $ 175 (+16%VAT)
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>CRANE - 20 Tons</td>
                                                                <td className="text-center">Per Hour/ MIN</td>
                                                                <td className="text-center">MIN 2 HOURS</td>
                                                                <td className="text-center" colSpan={2}>
                                                                    $ 195 (+16%VAT)
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>LABOUR CHARGES</td>
                                                                <td className="text-center">Per Hour/ MIN</td>
                                                                <td className="text-center">MIN 4 HOURS</td>
                                                                <td className="text-center" colSpan={2}>
                                                                    $ 10 PER HOUR
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>JACK PALLET</td>
                                                                <td className="text-center">Per Hour/ MIN</td>
                                                                <td className="text-center">MIN 2 HOURS</td>
                                                                <td className="text-center" colSpan={2}>
                                                                    $ 10 PER HOUR
                                                                </td>
                                                            </tr>
                                                            <tr style={{ backgroundColor: "#ddd" }}>
                                                                <td colSpan={5}>
                                                                    <strong>PARTICULARS</strong>
                                                                </td>
                                                            </tr>
                                                            <tr style={{ backgroundColor: "#ddd" }}>
                                                                <td colSpan={3}>
                                                                    ONSITE HANDLING &amp; FREIGHT FORWARDERS
                                                                </td>
                                                                <td colSpan={2}>UNIT</td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan={3}>
                                                                    OFFLOADING AT VENUE AND SHIFTING TO BOOTH (ONE LIFT
                                                                    ONLY)
                                                                </td>
                                                                <td colSpan={2}>$ 45/PER CBM MIN $ 130</td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan={3}>
                                                                    UN-PACKING &amp; DE-PALLETISATION IN ONE OPERATION
                                                                </td>
                                                                <td colSpan={2}>$ 45/PER CBM MIN $ 80</td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan={3}>
                                                                    POSITIONING &amp; RE-POSITIONING OF THE EXHIBITS (EACH
                                                                    TIME) IF APPLICABLE
                                                                </td>
                                                                <td colSpan={2}>$ 30/PER CBM MIN $40</td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan={3}>
                                                                    REMOVAL OF EMPTIES FOR STORAGE &amp; RETURN AFTER
                                                                    CLOSURE OF THE SHOW
                                                                </td>
                                                                <td colSpan={2}>
                                                                    $ 30 PER CBM MIN $ 70 PER ONE WAY TRIP
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan={3}>
                                                                    REMOVAL FROM STAND AND LOADING ON VEHICLE IN ONE
                                                                    OPERATION
                                                                </td>
                                                                <td colSpan={2}>$ 45 PER CBM MIN $ 140</td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan={3}>
                                                                    RE-PACKING OF EXHIBITS OR PALLETISATION OF EXHIBITS
                                                                    WITH SAME PACKING MATERIAL
                                                                </td>
                                                                <td colSpan={2}>$ 20 PER CBM MIN $ 40</td>
                                                            </tr>
                                                            <tr style={{ backgroundColor: "#ddd" }}>
                                                                <td colSpan={5}>
                                                                    <strong>HEAVY LIFT CHARGES</strong>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan={3}>
                                                                    ABOVE 3000 KGS, BELOW 5000 KGS (SINGLE)
                                                                </td>
                                                                <td colSpan={2}>$ 25.00 per 1000kgs Extra</td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan={3}>
                                                                    ABOVE 5000 KGS, BELOW 8000 KGS (SINGLE
                                                                </td>
                                                                <td colSpan={2}>$ 30.00 per 1000kg Extra</td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan={3}>ABOVE 8000 KGS (SINGLE)</td>
                                                                <td colSpan={2}>Subject to individual quote</td>
                                                            </tr>
                                                            <tr style={{ backgroundColor: "#ddd" }}>
                                                                <td colSpan={5}>
                                                                    <strong>
                                                                        HIRE OF EQUIPMENTS FOR ASSEMBLY AND ERECTION OF
                                                                        MACHINES
                                                                    </strong>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan={3}>HYDRAULIC PALLETS - 2 Tons</td>
                                                                <td colSpan={2}>
                                                                    $30 (+16% VAT) Per Hour/ MIN 2HOURS{" "}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan={3}>FORKLIFT - 3 Tons</td>
                                                                <td colSpan={2}>
                                                                    $ 70 (+16% VAT) Per Hour/ MIN 3HOURS
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan={3}>FORKLIFT - 5 Tons</td>
                                                                <td colSpan={2}>
                                                                    $ 90 (+16% VAT) Per Hour/ MIN 3HOURS
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan={3}>FORKLIFT - 10 Tons</td>
                                                                <td colSpan={2}>
                                                                    $ 140 (+16% VAT) Per Hour/ MIN 3HOURS
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan={3}>FORKLIFT - 10 Tons</td>
                                                                <td colSpan={2}>
                                                                    $140 (+16% VAT) Per Hour/ MIN 3HOURS
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan={3}>FORKLIFT - 12 Tons</td>
                                                                <td colSpan={2}>
                                                                    $ 165 (+16%VAT) Per Hour/ MIN 2HOURS
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan={3}>FORKLIFT - 15 Tons</td>
                                                                <td colSpan={2}>
                                                                    $ 175 (+16%VAT) Per Hour/ MIN 2HOURS
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan={3}>FORKLIFT - 20 Tons</td>
                                                                <td colSpan={2}>$ 195 (+16%VAT) Per Hour/MIN 2HOURS</td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan={3}>LABOUR CHARGES</td>
                                                                <td colSpan={2}>$ 10 PER HOUR Per Hour/ MIN 4HOURS</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </>
        )
    }
}
export default withRouter(connect(null, {})(FreightForward))